export default __webpack_public_path__ + "static/media/DSC02190.21dc2e1f.jpg";